module.exports = __webpack_public_path__ + "static/media/results_table.2faaab0b.png";